import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";

// Blog/note descriptions are stored as raw Quill Delta JSON
// ({"ops":[{"insert":"...", "attributes":{...}}]}), not plain HTML or
// plain text. Every place that previously just dumped `description`
// into innerHTML or a plain-text excerpt was showing the literal JSON
// string, since it's not valid markup for the browser to parse.
//
// Both functions fall back to treating the input as already-plain
// text/HTML if it's not valid Delta JSON -- in case any older posts were
// authored directly rather than through Quill, so those aren't broken
// by this change.

function parseDelta(description) {
  if (!description) return null;
  try {
    const parsed = JSON.parse(description);
    if (parsed && Array.isArray(parsed.ops)) return parsed;
    return null;
  } catch {
    return null;
  }
}

// Plain text only -- for card excerpts, where formatting doesn't matter
// and only readable text is needed. Skips non-string inserts (embedded
// images/videos represented as objects rather than text).
export function deltaToPlainText(description) {
  const delta = parseDelta(description);
  if (!delta) return description || ""; // not Delta JSON -- treat as already-plain text
  return delta.ops
    .map((op) => (typeof op.insert === "string" ? op.insert : ""))
    .join("");
}

// Real HTML, preserving actual formatting (bold, colors, links, lists,
// etc.) -- for full post pages using dangerouslySetInnerHTML.
export function deltaToHtml(description) {
  const delta = parseDelta(description);
  if (!delta) return description || ""; // not Delta JSON -- treat as already-HTML
  const converter = new QuillDeltaToHtmlConverter(delta.ops, {});
  return converter.convert();
}
